import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from "../../config/ApiConstants";

export function organisation_details_action(token, organisId, search, tagId,per_page,page) {
    return {
      [RSAA]: {
        endpoint: `${API_ENDPOINT}/organisation/details?q=${search}&tagId=${tagId}&per_page=${per_page}&page=${page}`,
        method: "GET",
        headers: {
          ...AUTH_HEADERS,
          'Authorization': 'Bearer ' + token,
          organisationId: organisId
        },
  
        // body: JSON.stringify(data),
        types: [
          types.ORGANISATION_DETAILS_REQUEST,
          types.ORGANISATION_DETAILS_RECEIVE,
          {
            type: types.ORGANISATION_DETAILS_FAILURE,
            meta: (action, state, res) => {
              return action, state, res;
            },
          },
        ],
      },
    };
  }
  
  export const reset_organisation_details_Action = () => {
    return {
      type: types.RESET_ORGANISATION_DETAILS,
      payload: null,
    };
  };